import axios from 'axios';
import { attachLoadingInterceptors } from './loadingBar';

const env = "production"; // Change this to "development" for local testing

const prod_url = "https://endpoint.elmanager.ma";
const local_url = "http://127.0.0.1:8000";
const doc_gen_url_prod = "https://docgen.elmanager.ma";

export const baseURL = env === "production" ? `${prod_url}/api` : `${local_url}/api`;
export const host = env === "production" ? prod_url : local_url;
export const doc_gen_url = env === "production" ? doc_gen_url_prod : 'http://127.0.0.1:8001';

export const API =  axios.create({
  baseURL: `${baseURL}`
});

attachLoadingInterceptors(API);

// Maintenance mode handling
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 503 &&
      error.response?.data?.maintenance === true
    ) {
      sessionStorage.setItem(
        "maintenanceMessage",
        error.response.data.message
      );

      window.location.href = "/maintenance";

      return;
    }

    return Promise.reject(error);
  }
);




export const getCountries = async () => {
  const response = await API.get("/countries");

  if(response.status === 200){
    return response.data.data;
  }

  throw("Error get countries");
}
